module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    class: {
      'control': true,
      'is-expanded': true,
      'is-loading': _vm.inProgress
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Send Reconfirmation E-Mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconfirm.email),
      expression: "reconfirm.email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "id": "email",
      "type": "text",
      "placeholder": "E-mail",
      "data-vv-rules": "required|email"
    },
    domProps: {
      "value": (_vm.reconfirm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconfirm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.errors.any(),
      'is-loading': _vm.inProgress
    },
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": _vm.reconfirmEmailService
    }
  }, [_vm._v("Send")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-707ed4a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/services/ReconfirmEmail.vue
// module id = 1157
// module chunks = 39